import DataTable from 'react-data-table-component';   
import type { TableProps } from 'react-data-table-component';
import { VehicleSaleStatus } from '../../../config/utils/helper';
type PaginationChangeRowsPerPage = NonNullable<TableProps<any>['onChangeRowsPerPage']>;

const {
    VEHICLE_SELL_STATUS,
    VEHICLE_PRE_BOOKED_STATUS,
    VEHICLE_BOOKED_STATUS,
    VEHICLE_SOLD_STATUS,
    VEHICLE_BUY_STATUS,
    VEHICLE_UNPUBLISH_STATUS
} = VehicleSaleStatus;

interface ReportDataProps {
    reportData:any
    handlePageChange:PaginationChangeRowsPerPage | undefined
    handlePerRowsChange:PaginationChangeRowsPerPage | undefined
}

const ModelWiseReport: React.FC<ReportDataProps> = ({reportData, handlePageChange, handlePerRowsChange}):any => {
    
    //Custom Style for the data table
    const customStyles = {
        headCells: {
            style: {
                fontSize: "15px",
                fontWeight: "700"
            },
        },
    };

    const saleStatusTypeArray = [
        { keyName: 'all', name: "All" },
        { keyName: VEHICLE_SELL_STATUS, name: "Sell" },
        { keyName: VEHICLE_PRE_BOOKED_STATUS, name: "Pre-Booked" },
        { keyName: VEHICLE_BOOKED_STATUS, name: "Booked" },
        { keyName: VEHICLE_SOLD_STATUS, name: "Sold" },
        { keyName: VEHICLE_BUY_STATUS, name: "Purchase" },
        { keyName: VEHICLE_UNPUBLISH_STATUS, name: "Unpublished" },
    ]


    const getSalesNamebyId = (keyName: number) => {
        console.log('keyName',keyName)
        const saleStatus = saleStatusTypeArray.find((status) => status.keyName === keyName);
        return saleStatus ? saleStatus.name : '';
    }

    //Column Declaraion for the data table
    const columns: any = [
        {
            name: <div>Make</div>,
            selector: (row: { make: string; }) => row.make,
            sortable: false,
            keyName: 'make'
        },
        {
            name: <div>Model</div>,
            wrap: true,
            sortable: false,
            keyName: 'model',
            width: "17%",
            selector: (row: {model: string}) => row.model,

        },
        {
            name: <div>Location</div>,
            wrap: true,
            sortable: false,
            keyName: 'locationName',
            width: "17%",
            selector: (row: { locationName: string }) => row.locationName,

        },
        {
            name: <div>Sale Status</div>,
            wrap: true,
            sortable: false,
            keyName: 'saleSatus',
            width: "17%",
            selector: (row: { saleStatus: number }) => getSalesNamebyId(row.saleStatus),

        },
        {
            name: 'Count',
            selector: (row: { vehicleCount: string; }) => row.vehicleCount,
            sortable: false,
        },
    ];

    return (<>
        <br></br>
        <DataTable
                columns={columns}
                data={reportData.rows}
                striped={true}
                pagination
                paginationServer
                paginationTotalRows={reportData.count}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                highlightOnHover={true}
                customStyles={customStyles}
            />
        
    </>)

}
export default ModelWiseReport